import IMG_RK1 from "./shared/icons/images/РК_1 1.png"
import IMG_RK2 from "./shared/icons/images/РК_2 1.png"
import IMG_RK3 from "./shared/icons/images/РК_3 1.png"


export const Config = {

    path: "/product/new_geocoder",
    //path: "/avs_debug",

    metricModuleId: "",

    texts: {
        appName: "Геокодер",
        title: ['Больше. Точнее. Богаче.'],
        subtitle: ['<a href="#features">Начните работу!</a>'],
        textInfos: [
            {
                upper: '',
                title: '',
                text: [
                    'Геокодер — инструмент для работы с адресами и координатами по всей России.',
                    'Преобразует адреса в координаты и обратно, анализирует и структурирует адресные данные.',
                ],
                img: IMG_RK1
            },
            {
                upper: '',
                title: 'Цифры и факты',
                text: [
                    '<b>40 млн</b> объектов с адресами на всю Россию',
                    'В среднем адресных признаков на каждый объект — <b>7.4 шт.</b>',
                    'Производительность Геокодера — до <b>40 шт./сек.</b>',
                    'Производительность Разборщика — до <b>100 шт./сек.</b>',
                    'Стоимость использования — от <b>7 копеек/шт.</b>',
                ],
                img: IMG_RK2
            },
            {
                upper: '',
                title: 'Преимущества',
                text: [
                    '<b>Высокая точность:</b> определяет местоположение с минимальной погрешностью, даже для сложных адресов и объектов в удаленных локациях',
                    '<b>Полные и актуальные данные:</b> работает с детализированными адресами, включая регионы, улицы и дома, с регулярным обновлением базы из нескольких источников',
                    '<b>Гибкость использования:</b> преобразует координаты в адрес и обратно, а также разбирает адреса на структурные компоненты для удобной интеграции',
                    '<b>Надёжная информационная основа:</b> работает на Объединённом Адресном Плане (ОАП) —  собственном продукте платформы «Робот-Картограф», который регулярно обновляется и автоматически проверяется.',
                    'Это гарантирует актуальность, достоверность и непротиворечивость данных, предоставляемых различными источниками',
                ],
                img: IMG_RK2
            },
            {
                upper: '',
                title: 'Для кого сервис',
                text: [
                    '<b>1. Для логистических компаний и служб доставки</b><br/>Кому помогаем: менеджерам логистики, диспетчерам, разработчикам систем маршрутизации<br/>Какую проблему решаем: точно определяем адреса доставки даже при неполных исходных данных',
                    '<b>2. Для агентств недвижимости и девелоперов</b><br/>Кому помогаем: агентам, застройщикам, кадастровым инженерам<br/>Какую проблему решаем: быстро проверяем характеристики объектов по адресу или координатам',
                    '<b>3. Для государственных служб и муниципалитетов</b><br/>Кому помогаем: сотрудникам МФЦ, градостроителям, специалистам служб ЖКХ<br/>Какую проблему решаем: создаём единый и полный реестр адресов и устраняем противоречия в данных',
                    '<b>4. Для разработчиков геосервисов</b><br/>Кому помогаем: разработчикам и аналитикам, создающим картографические сервисы<br/>Какую проблему решаем:  осуществляем точное геокодирование для компаний, у которых нет собственной инфраструктуры',
                ],
                img: IMG_RK2
            },
            {
                upper: '',
                title: 'Алгоритм работы',
                text: [
                    '<b>Прямое геокодирование:</b> вы указываете адрес, а Геокодер возвращает точные координаты и характеристики здания',
                    '<b>Обратное геокодирование:</b> вы задаёте координаты, а Геокодер находит адрес здания в этой точке (или ближайшего к ней объекта)',
                    'Геокодер умеет и то, и другое. А ещё он может работать сразу в двух режимах: передайте все известные признаки объекта (адрес, координаты, части описания), и Геокодер подберёт наиболее точное соответствие',
                    'Если данные противоречивы, Геокодер не вернёт некорректный результат. И это тоже важно: лучше ничего, чем ошибка'
                ],
                img: IMG_RK2
            },
            {
                upper: '',
                title: 'Рекомендации по использованию',
                text: [
                    'Мы ценим открытость, поэтому заранее рассказываем о текущих возможностях системы. На данный момент Геокодер:',
                    '— работает исключительно с адресами на территории России на русском языке',
                    '— может требовать уточнения при значительных опечатках или нестандартных формулировках адресов',
                    '— в сложных имущественных комплексах (промзоны, медицинские городки) иногда требует ручного выбора конкретного здания из предложенных вариантов',
                    'Эти особенности мы постоянно совершенствуем в новых версиях системы'
                ],
                img: IMG_RK2
            },
            {
                upper: '',
                title: 'О компании',
                text: [
                    'АО «Самара-Информспутник» — компания с опытом работы более 25 лет в сфере геоинформатики вышла в 2025 году на федеральный уровень под брендом «САМИС».',
                    'Компания занимается созданием наукоёмкой продукции в области информационных технологий, её внедрением в опытно-конструкторские разработки, производство и социальную сферу',
                ],
                img: IMG_RK3
            }
        ],
        footer: {
            text: []
        },
        report: {
            button: "",
            header: "Заинтересовали",
            hint: "Свяжитесь с нами<br/>и мы поможем подобрать оптимальный для вас тариф",
            thanks: "Спасибо, мы с вами свяжемся в ближайшее время!",
            noRegionStub: "или возникли вопросы?",
            placeholder: "Почта или телефон",
            whereFromPlaceholder: "Откуда вы",
            request: "ОТПРАВИТЬ"
        },
        drawing: {
            default: '',
            start: '',
            stop: ''
        }
    },

    layers: [],
    featureInfo: {
        properties: [],
        territoryNameFunc: (properties) => { return "" },
        headerFunc: (properties) => { return "" },
        subHeaderFunc: (properties) => { return "" }
    },
    featureId: (feature) => { }
}

